import * as types from '../actions/actionTypes'
import * as loadMoreReducerHelper from '../libs/loadMoreReducerHelper'

export const initialState = {
  list: loadMoreReducerHelper.createInitialState(), // requestGetOutflowHistories result
  transactions: {}, // key = transactionId, value = requestGetOutflowPaymentDetail result
  withdraws: {}, // key = withdrawId, value = requestGetOutflowWithdrawDetail result
}

export default function outflowHistoryReducer(
  outflowHistory = initialState,
  action,
) {
  const { list } = outflowHistory
  const { payload } = action
  switch (action.type) {
    case types.GET_OUTFLOW_HISTORIES:
      return {
        ...outflowHistory,
        list: loadMoreReducerHelper.onStartFetching(list),
      }
    case types.GET_OUTFLOW_HISTORIES_SUCCESS:
      return {
        ...outflowHistory,
        list: loadMoreReducerHelper.onFetchSuccess(
          list,
          payload.records,
          payload.replace,
        ),
      }
    case types.GET_OUTFLOW_HISTORIES_ERROR:
      return {
        ...outflowHistory,
        list: loadMoreReducerHelper.onFetchError(list),
      }
    case types.GET_OUTFLOW_PAYMENT_DETAIL_SUCCESS: {
      const { transactionId } = payload
      return {
        ...outflowHistory,
        transactions: {
          [transactionId]: payload.data,
        },
      }
    }
    case types.GET_OUTFLOW_PAYMENT_DETAIL_ERROR:
      return {
        ...outflowHistory,
        transactions: {
          [payload.transactionId]: null,
        },
      }
    case types.GET_OUTFLOW_WITHDRAW_DETAIL_SUCCESS: {
      const { withdrawId } = payload
      return {
        ...outflowHistory,
        withdraws: {
          [withdrawId]: payload.data,
        },
      }
    }
    case types.GET_OUTFLOW_WITHDRAW_DETAIL_ERROR:
      return {
        ...outflowHistory,
        withdraws: {
          [payload.withdrawId]: null,
        },
      }
    case types.RESET_WITHDRAW_SUCCEEDED:
      // * push withdraw into list.items
      if (list.items[0]?.id === payload.id) {
        return outflowHistory
      }
      return {
        ...outflowHistory,
        list: {
          ...list,
          items: [payload, ...list.items],
        },
      }
    case types.MARK_WITHDRAW_SHOWN: {
      const item = list.items[0]
      if (item && item._created) {
        return {
          ...outflowHistory,
          list: loadMoreReducerHelper.updateSingleItem(
            list,
            {
              _animated: true,
            },
            (item, index) => index === 0,
          ),
        }
      }
      return outflowHistory
    }
    default:
      return outflowHistory
  }
}
